module.exports = __webpack_public_path__ + "static/media/qrCardMx.9a2f33e0.png";